import { useCallback } from 'react'
import { get } from 'aws-amplify/api'
import { useAppContext, actionTypes } from '../context/AppContext'

export function useRepoStrings() {
  const { state, dispatch } = useAppContext()
  
  const fetchRepoStrings = useCallback(async (repository, bugIndex, stringIndex) => {
    dispatch({ type: actionTypes.FETCH_REPOSTRINGS_START })
    
    try {
      console.log(repository)
      const { response } = get({
        apiName: 'FetchResources',
        path: `repositories/${repository._id}/resources`
      })
      const res = await response
      const data = await res.body.json()
      
      // Get repository name (with description if available)
      const repoName = repository.description 
        ? `${repository.name} - ${repository.description}` 
        : repository.name
      
      dispatch({
        type: actionTypes.FETCH_REPOSTRINGS_SUCCESS,
        payload: data,
        repoName: repoName
      })
      
      // Also add to suggestions
      dispatch({
        type: actionTypes.ADD_REPO_STRING_SUGGESTION,
        repository: data,
        bugIndex,
        stringIndex
      })
    } catch (error) {
      console.error(error)
      dispatch({ type: actionTypes.FETCH_REPOSTRINGS_ERROR })
    }
  }, [dispatch])
  
  return {
    repoStrings: state.repoStrings,
    fetchRepoStringsInProgress: state.fetchRepoStringsInProgress,
    fetchRepoStringsHasErrored: state.fetchRepoStringsHasErrored,
    fetchRepoStrings
  }
}
